import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { BlankV2ElementProps } from './components/BlankV2Element';
import { BLANK_V2, BlankV2Options } from './types';

const BlankV2Element = dynamicEditorComponent<BlankV2ElementProps>(() =>
  import('./components/BlankV2Element').then((mod) => mod.BlankV2Element)
);

export const renderElementBlankV2 = (options: BlankV2Options) => (props: RenderElementProps) => {
  const { element } = props;

  if (element.type === BLANK_V2) {
    return <BlankV2Element {...props} />;
  }

  return undefined;
};
